import { format } from "date-fns";
import { es } from "date-fns/esm/locale";

type Falsy = boolean | undefined | null | 0;

export const articleDateFormat = (stringDate) => {
  if (!stringDate) {
    return null;
  }

  const date = new Date(stringDate);

  return format(date, "dd 'de' MMMM yyyy", { locale: es });
};

export const metaDateFormat = (stringDate) => {
  if (!stringDate) {
    return null;
  }

  const date = new Date(stringDate);

  return format(date, "MM-dd-yy");
};

export const ScrollToTop = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

export const classNames = (...classes: (string | Falsy)[]) => {
  return classes.filter(Boolean).join(" ");
};

export const toCurrency = (value: number | string): string => {
  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  if (isNaN(numericValue)) {
    console.error("Invalid number input for currency conversion");
    return "Invalid Number";
  }

  return numericValue.toLocaleString("es-MX", {
    style: "currency",
    currency: "MXN",
  });
};
